// @flow
const addTrackingPixel = (url: string): void => {
    new Image().src = url;
};

export { addTrackingPixel };



// WEBPACK FOOTER //
// ./static/src/javascripts/projects/commercial/modules/creatives/add-tracking-pixel.js